import React from 'react'
import List from '../pages/list'

export const PagesInstitutionalList = (props) => <List {...props} filter={{ collection: 'institutional' }} title="Pages Institutional" />

export default PagesInstitutionalList
